export const isEmpty = (val: string) => val.length === 0;
